var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#F5F6FA",
    stroke: "#030659"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.118 16.1798C15.7923 16.1794 15.4759 16.0707 15.219 15.8709C14.9822 15.6898 14.7992 15.4477 14.6897 15.1707L12.2711 9.39622L9.89091 15.1635C9.78595 15.4478 9.60226 15.6964 9.36122 15.8806C9.10591 16.075 8.79346 16.1799 8.47233 16.179C7.89859 16.179 7.55838 15.9265 7.37414 15.7148C7.14481 15.4471 7.01295 15.1098 7 14.7578V14.7372V14.7162C7.00229 14.5497 7.03093 14.3846 7.08485 14.227L7.09374 14.2004L10.8602 5.00988C10.9795 4.70485 11.1883 4.44293 11.4594 4.25852C11.7078 4.09046 12.0009 4.00042 12.301 4C12.3249 4 12.3487 4 12.3729 4C12.6785 4.00608 12.9752 4.10359 13.2247 4.27989C13.4854 4.46246 13.6841 4.72007 13.7944 5.01834L17.5051 14.0479C17.5805 14.2368 17.6196 14.4382 17.6202 14.6416C17.6202 15.0852 17.4586 15.4704 17.1519 15.7588C16.8749 16.0275 16.5043 16.1785 16.118 16.1798Z",
    fill: "#030659"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.99f068ca4488cbdeedb0ae0703938d97.svg";
export { ForwardRef as ReactComponent };